'use strict';

module.exports = /*@ngInject*/ ["$filter", function ScreenLoggerFactory($filter) {
    var ScreenLoggerFactory = function () {
        "use strict";

        var self = this;

        var log = [];

        self.changed = false;

        var init = function () {
            "use strict";
            self.addLogEntry("Logger initialized");
            self.changed = true;
        };

        self.addLogEntry = function (entryString) {
            var object = {
                date: new Date(),
                value: entryString
            };
            log.push(object);
            self.changed = true;
        };

        self.getLog = function () {
            var array = [];
            log.forEach(function (l) {
                var logString = "[" + $filter('date')(l.date, 'dd MMM yyyy HH:mm:ss') + "] " + l.value;
                array.push(logString)
            });
            self.changed = false;
            return array;
        };

        init();

        return self;
    };

    return ScreenLoggerFactory;
}];